import { useFillPathway } from '../../../../contexts/fill/use-fill-prescription';
import { InsuranceCoverageNotice } from '../insurance/InsuranceCoverageNotice';
import { SelfPayCoverageNotice } from '../self-pay/SelfPayCoverageNotice';

export const CoverageNotice = () => {
    const { pathway } = useFillPathway();

    switch (pathway) {
        case 'insurance':
            return <InsuranceCoverageNotice />;
        case 'self-pay':
            return <SelfPayCoverageNotice />;
    }

    return <></>;
};
